window.SDG = window.SDG || {};
SDG.Data = SDG.Data || {};
SDG.Data.staticLocations = [
  {
    "id": "gid://shopify/Location/85367947375",
    "name": "Arabella Plaza, 5th Settlement",
    "address": {
      "address1": "Arabella Plaza, 5th Settlement",
      "address2": "",
      "city": "Cairo",
      "province": "Cairo",
      "provinceCode": "C",
      "zip": "",
      "country": "Egypt",
      "phone": "01114515129",
      "latitude": 29.9912896,
      "longitude": 31.4331227,
      "formatted": [
        "Arabella Plaza, 5th Settlement",
        "Cairo, Cairo",
        "Egypt"
      ]
    },
    "enableToggles": {
      "value": "{\"storeLocatorEnabled\":true,\"checkoutEnabled\":false}"
    },
    "pickupMessages": null,
    "phoneOverride": {
      "value": "01114515129"
    },
    "email": {
      "value": "info@switchpluseg.com"
    },
    "hours": {
      "value": "Ramadan: 10:00AM - 4:00PM / 8:00PM - 12:00AM (Except Thu & Fri 8:00PM - 01:00AM)"
    },
    "services": null,
    "image": null,
    "mapsUrl": {
      "value": "https://goo.gl/maps/Fsp8fmcrAdt2BbfJA"
    }
  },
  {
    "id": "gid://shopify/Location/85367849071",
    "name": "Capital Business Park, Sheikh Zayed",
    "address": {
      "address1": "Capital Business Park, 26 of July Corridor",
      "address2": "",
      "city": "6-October City",
      "province": "Giza",
      "provinceCode": "GZ",
      "zip": "",
      "country": "Egypt",
      "phone": "01154443303",
      "latitude": 30.0555372,
      "longitude": 31.0738167,
      "formatted": [
        "Capital Business Park, 26 of July Corridor",
        "6-October City, Giza",
        "Egypt"
      ]
    },
    "enableToggles": {
      "value": "{\"storeLocatorEnabled\":true,\"checkoutEnabled\":false}"
    },
    "pickupMessages": null,
    "phoneOverride": {
      "value": "01154443303"
    },
    "email": {
      "value": "info@switchpluseg.com"
    },
    "hours": {
      "value": "Ramadan: 10:00AM - 4:00PM / 8:00PM - 12:00AM (Except Thu & Fri 8:00PM - 01:00AM)"
    },
    "services": null,
    "image": null,
    "mapsUrl": {
      "value": "https://g.page/switchplus-capital?share/"
    }
  },
  {
    "id": "gid://shopify/Location/85367783535",
    "name": "CFC Mall, 5th Settlement",
    "address": {
      "address1": "3rd Floor, Store # 2-073 & 2-074, Cairo Festival City Mall",
      "address2": "Road 90, 5th Settlement",
      "city": "Cairo",
      "province": "Cairo",
      "provinceCode": "C",
      "zip": "",
      "country": "Egypt",
      "phone": "01110079372",
      "latitude": 30.02881039999999,
      "longitude": 31.4076654,
      "formatted": [
        "3rd Floor, Store # 2-073 & 2-074, Cairo Festival City Mall",
        "Road 90, 5th Settlement",
        "Cairo, Cairo",
        "Egypt"
      ]
    },
    "enableToggles": {
      "value": "{\"storeLocatorEnabled\":true,\"checkoutEnabled\":false}"
    },
    "pickupMessages": null,
    "phoneOverride": {
      "value": "01110079372"
    },
    "email": {
      "value": "info@switchpluseg.com"
    },
    "hours": {
      "value": "Ramadan: 10:00AM - 4:30PM / 7:30PM - 12:00AM (Except Thu & Fri 8:00PM - 01:00AM)"
    },
    "services": null,
    "image": null,
    "mapsUrl": {
      "value": "https://g.page/switchplus-cfc?share"
    }
  },
  {
    "id": "gid://shopify/Location/85368012911",
    "name": "City Center Maadi",
    "address": {
      "address1": "City Center Maadi, Ring Road",
      "address2": "",
      "city": "Cairo",
      "province": "Cairo",
      "provinceCode": "C",
      "zip": "",
      "country": "Egypt",
      "phone": "01144451797",
      "latitude": 29.9827244,
      "longitude": 31.3162651,
      "formatted": [
        "City Center Maadi, Ring Road",
        "Cairo, Cairo",
        "Egypt"
      ]
    },
    "enableToggles": {
      "value": "{\"storeLocatorEnabled\":true,\"checkoutEnabled\":false}"
    },
    "pickupMessages": null,
    "phoneOverride": {
      "value": "01144451797"
    },
    "email": {
      "value": "info@switchpluseg.com"
    },
    "hours": {
      "value": "Ramadan: 10:00AM - 5:00PM / 7:00PM - 12:00AM (Except Thu & Fri 7:00PM - 01:00AM)"
    },
    "services": null,
    "image": null,
    "mapsUrl": {
      "value": "https://goo.gl/maps/ip3gakWWoMBjimeB8"
    }
  },
  {
    "id": "gid://shopify/Location/85368111215",
    "name": "Maadi",
    "address": {
      "address1": "2 Port Said St",
      "address2": "",
      "city": "Maadi, Cairo",
      "province": "Cairo",
      "provinceCode": "C",
      "zip": "",
      "country": "Egypt",
      "phone": "0223802419",
      "latitude": 29.9591968,
      "longitude": 31.2695719,
      "formatted": [
        "2 Port Said St",
        "Maadi, Cairo, Cairo",
        "Egypt"
      ]
    },
    "enableToggles": {
      "value": "{\"storeLocatorEnabled\":true,\"checkoutEnabled\":false}"
    },
    "pickupMessages": null,
    "phoneOverride": {
      "value": "0223802419, 01125244442"
    },
    "email": {
      "value": "info@switchpluseg.com"
    },
    "hours": {
      "value": "Ramadan: 10:00AM - 4:00PM / 8:00PM - 12:00AM (Except Thu & Fri 8:00PM - 01:00AM)"
    },
    "services": null,
    "image": null,
    "mapsUrl": {
      "value": "https://g.page/switchplus-maadi?share"
    }
  },
  {
    "id": "gid://shopify/Location/85219410031",
    "name": "Mohandessin",
    "address": {
      "address1": "7, El-Thawra Square (near Shooting Club)",
      "address2": "",
      "city": "Mohandessin",
      "province": "Giza",
      "provinceCode": "GZ",
      "zip": "3751320",
      "country": "Egypt",
      "phone": "01110079380",
      "latitude": 30.0483596,
      "longitude": 31.2046445,
      "formatted": [
        "7, El-Thawra Square (near Shooting Club)",
        "Mohandessin, Giza",
        "3751320",
        "Egypt"
      ]
    },
    "enableToggles": {
      "value": "{\"storeLocatorEnabled\":true,\"checkoutEnabled\":false}"
    },
    "pickupMessages": null,
    "phoneOverride": {
      "value": "0233350375, 01110079380"
    },
    "email": {
      "value": "info@switchpluseg.com"
    },
    "hours": {
      "value": "Ramadan: 10:00AM - 4:00PM / 8:00PM - 12:00AM (Except Thu & Fri 8:00PM - 01:00AM)"
    },
    "services": null,
    "image": null,
    "mapsUrl": {
      "value": "https://g.page/Switchplus-dokki?share"
    }
  },
  {
    "id": "gid://shopify/Location/85367816303",
    "name": "Rafale Mall, Heliopolis",
    "address": {
      "address1": "22 Ahmed Tayseer, off to El-Merghany",
      "address2": "",
      "city": "Cairo",
      "province": "Cairo",
      "provinceCode": "C",
      "zip": "",
      "country": "Egypt",
      "phone": "01122275645",
      "latitude": 30.0795488,
      "longitude": 31.3261521,
      "formatted": [
        "22 Ahmed Tayseer, off to El-Merghany",
        "Cairo, Cairo",
        "Egypt"
      ]
    },
    "enableToggles": {
      "value": "{\"storeLocatorEnabled\":true,\"checkoutEnabled\":false}"
    },
    "pickupMessages": null,
    "phoneOverride": {
      "value": "01122275645"
    },
    "email": {
      "value": "info@switchpluseg.com"
    },
    "hours": {
      "value": "Ramadan: 10:00AM - 4:00PM / 8:00PM - 12:00AM (Except Thu & Fri 8:00PM - 01:00AM)"
    },
    "services": null,
    "image": null,
    "mapsUrl": {
      "value": "https://g.page/SwitchPlus-Heliopolis?share"
    }
  },
  {
    "id": "gid://shopify/Location/85367881839",
    "name": "Senzo Mall, Hurghada",
    "address": {
      "address1": "Store #21A, Senzo Mall",
      "address2": "",
      "city": "Hurghada",
      "province": "Red Sea",
      "provinceCode": "BA",
      "zip": "",
      "country": "Egypt",
      "phone": "0653464054",
      "latitude": 27.0955375,
      "longitude": 33.8219067,
      "formatted": [
        "Store #21A, Senzo Mall",
        "Hurghada, Red Sea",
        "Egypt"
      ]
    },
    "enableToggles": {
      "value": "{\"storeLocatorEnabled\":true,\"checkoutEnabled\":false}"
    },
    "pickupMessages": null,
    "phoneOverride": {
      "value": "0653464054"
    },
    "email": {
      "value": "info@switchpluseg.com"
    },
    "hours": {
      "value": "Ramadan: 10:00AM - 5:30PM / 6:30PM - 12:00AM (Except Thu & Fri 6:30PM - 12:00AM)"
    },
    "services": null,
    "image": null,
    "mapsUrl": {
      "value": "https://g.page/switchplus-senzo?share/"
    }
  },
  {
    "id": "gid://shopify/Location/85367980143",
    "name": "Smouha",
    "address": {
      "address1": "8 Fawzi Moaz st, Continental Towers",
      "address2": "",
      "city": "Smouha, Alexandria",
      "province": "Alexandria",
      "provinceCode": "ALX",
      "zip": "",
      "country": "Egypt",
      "phone": "01141888027",
      "latitude": 31.2098497,
      "longitude": 29.9367405,
      "formatted": [
        "8 Fawzi Moaz st, Continental Towers",
        "Smouha, Alexandria, Alexandria",
        "Egypt"
      ]
    },
    "enableToggles": {
      "value": "{\"storeLocatorEnabled\":true,\"checkoutEnabled\":false}"
    },
    "pickupMessages": null,
    "phoneOverride": {
      "value": "01141888027, 034258650"
    },
    "email": {
      "value": "info@switchpluseg.com"
    },
    "hours": {
      "value": "Ramadan: 10:00AM - 4:00PM / 8:00PM - 12:00AM (Except Thu & Fri 8:00PM - 01:00AM)"
    },
    "services": null,
    "image": null,
    "mapsUrl": {
      "value": "http://bit.ly/2KKLz48"
    }
  },
  {
    "id": "gid://shopify/Location/85032534127",
    "name": "Zamalek",
    "address": {
      "address1": "3 Ibn El Nabih Street",
      "address2": "",
      "city": "Zamalek, Cairo",
      "province": "Cairo",
      "provinceCode": "C",
      "zip": "",
      "country": "Egypt",
      "phone": "01110500998",
      "latitude": 30.0570732,
      "longitude": 31.2226013,
      "formatted": [
        "3 Ibn El Nabih Street",
        "Zamalek, Cairo, Cairo",
        "Egypt"
      ]
    },
    "enableToggles": {
      "value": "{\"storeLocatorEnabled\":true,\"checkoutEnabled\":false}"
    },
    "pickupMessages": null,
    "phoneOverride": {
      "value": "01110500998, 0227356036"
    },
    "email": {
      "value": "info@switchpluseg.com"
    },
    "hours": {
      "value": "Ramadan: 10:00AM - 4:00PM / 8:00PM - 12:00AM (Except Thu & Fri 8:00PM - 01:00AM)"
    },
    "services": null,
    "image": null,
    "mapsUrl": {
      "value": "https://g.page/Switchplus-zamalek?share"
    }
  }
];
